import React from 'react';
import { Box, Text, Center } from '@chakra-ui/react';

interface ScriptEditorProps {
  // Future props can be added here
}

const ScriptEditor: React.FC<ScriptEditorProps> = () => {
  return (
    <Box
      height="100vh"
      width="100%"
      bg="gray.50"
      p={8}
    >
      <Center height="100%">
        <Text
          fontSize="4xl"
          fontWeight="bold"
          color="blue.600"
          textAlign="center"
        >
          Hello Coders
        </Text>
      </Center>
    </Box>
  );
};

export default ScriptEditor;